import { useCallback } from 'react';
import { ResponseError } from 'services/api/base';
import { useSeasonalComparatorDeletePreferenceMutation } from 'services/api/Meteorology/Weather/SeasonalComparator';
import { useHandleRequestErrors } from 'utils/hooks';

export default function useDeletePreference() {
  const [trigger, { isLoading, error }] = useSeasonalComparatorDeletePreferenceMutation();
  const preferenceDeleteTrigger = useCallback((id: number) => () => {
    trigger({ id });
  }, [trigger]);

  useHandleRequestErrors(error as ResponseError | undefined);

  return {
    preferenceDeleteTrigger,
    deleteLoading: isLoading,
  };
}
